import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { BcAccountClientService } from '../service/bc-account-client.service';
import { IMyDpOptions } from 'mydatepicker';

export interface AlertModel {
  clientObj;
}

@Component({
  selector: 'app-bc-visitation',
  templateUrl: './bc-visitation.component.html',
  styleUrls: ['./bc-visitation.component.scss'],
  providers: [BcAccountClientService]
})
export class BcVisitationComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {
 

  clientObj;
  private clientID;
  private visitations = [];
  private isReturn = false;
  private dateReturn;
  private position;

  private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels:{su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

    constructor(dialogService: DialogService,
                private bcAccountClientService:BcAccountClientService) {                  
      super(dialogService);
    }

     
  ngOnInit(){
    this.clientID = this.clientObj.ID
    this.getVisitationData();
  }

  getVisitationData(){
    this.bcAccountClientService.getVisitation(this.clientID).subscribe(result => {
			if (result.Success) {
        this.visitations = result.Result;
        if (this.visitations.length > 0){
         this.visitations[0].DataParecer? this.isReturn = false : this.isReturn = true;
        }
        console.log("Visitas", this.visitations);
			} else {
				console.log("deu erro aqui", result);
			}
		}, error => {
			console.log(error);
		});
  }

  requestVisitation(){
      this.bcAccountClientService.requestVisitation(this.clientID).subscribe(result => {
        if (result.Success) {
          this.getVisitationData();
        } else {
          console.log("deu erro aqui requestVisitation", result);
        }
      }, error => {
        console.log(error);
      });
  }

  returnVisitation(){

    const tempDateReturn = this.dateReturn? this.dateReturn.date.year+"-"+this.dateReturn.date.month+"-"+this.dateReturn.date.day: null
    
    this.bcAccountClientService.returnVisitation(this.visitations[0].ID, this.clientID, this.position, tempDateReturn).subscribe(result => {
      if (result.Success) {
        this.dateReturn = null;
        this.position = null;
        this.getVisitationData();
      } else {
        console.log("deu erro aqui returnVisitation", result);
      }
    }, error => {
      console.log(error);
    });
}
  

  
  confirm() {
    this.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-visitation/bc-visitation.component.ts